import { useLoggedInMember } from "@/modules/auth/states";
import { getZaniaTeamMemberRoles } from "@/modules/team/states";
import { useFeatureAccess } from "@/shared/hooks/use-feature-access";
import { mainSidebarItems } from "../constants/sidebar";

export function useFirstAccessibleRoute(): string | null {
  const loggedInMember = useLoggedInMember();
  const featureNames = mainSidebarItems
    .map((item) => item.featureName)
    .filter((name): name is string => name !== undefined);
  const featureAccess = useFeatureAccess({ features: featureNames });
  const userPermissions = loggedInMember
    ? getZaniaTeamMemberRoles("", loggedInMember)
    : { canAccessZaniaAskAi: false };

  const firstAccessible = mainSidebarItems.find((item) => {
    if (item.isPlaceholder) return false;
    if (item.canAccess && !item.canAccess(userPermissions)) return false;
    if (item.featureName) {
      const accessKey =
        `has${item.featureName.charAt(0).toUpperCase()}${item.featureName.slice(1)}Access` as keyof typeof featureAccess;
      if (!featureAccess[accessKey]) return false;
    }
    return true;
  });

  return firstAccessible?.path ?? null;
}
